(function () {
  'use strict';
  if (window.LP2DBenefits) { window.LP2DBenefits.init(); return; }
  const instances = new Map();
  const mobile = matchMedia('(max-width: 749px)');
  let dialog;
  let opener;
  // Desktop clearance between the sticky media column's lower edge and the
  // viewport bottom. It keeps the benefits row just above Omnisend's
  // bottom-left "Get 20% off" teaser (bottom: 16px, ~52px tall at scale(1.3),
  // see layout/theme.liquid). 16px bottom + 52px height + 4px gap = 72px.
  // Re-measure this constant if the teaser's size or scale changes.
  const DESKTOP_BOTTOM_CLEARANCE = 72;
  // When the gallery fits under the header, the old formula pinned it there
  // and left a gap between the benefits row and the teaser. Let the column
  // drop up to this many pixels instead; the cap keeps a very tall viewport
  // from parking the gallery far below the product info.
  const MAX_HEADER_DROP = 64;

  function visible(element) {
    return !element.closest('[hidden], [aria-hidden="true"]') &&
      element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }

  function showDetails(button) {
    opener = button;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'lp-2d-video-details';
      dialog.setAttribute('aria-label', 'Painting Video Included');
      const text = document.createElement('p');
      text.textContent = "We film the painting process for you to watch your portrait come to life. Every pet deserves a hand-painted portrait by an pet-loving artist.";
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'lp-2d-video-details__close';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '\u00d7';
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, text);
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      document.body.append(dialog);
    }
    if (!dialog.open) dialog.showModal();
  }

  function enhance(root) {
    if (instances.has(root) || root.closest('quick-add-modal')) return;
    const slot = root.querySelector('[data-lp-2d-benefits-slot]');
    const benefits = slot?.querySelector('[data-lp-2d-benefits]');
    const media = slot?.closest('.product__media-wrapper');
    const info = root.querySelector('.product__info-container');
    if (!benefits || !media || !info) return;
    const bottomClearance = ['2d', '3d'].includes(root.dataset.lpBenefitsType) ? 44 : DESKTOP_BOTTOM_CLEARANCE;
    let frame;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(render);
    };

    function render() {
      if (mobile.matches) {
        const next = [...info.querySelectorAll('.mw-group__button-next')]
          .find(button => !button.closest('.mw-tingle, quick-add-modal') && visible(button));
        const row = next?.closest('.mw-group__button') ||
          [...info.querySelectorAll('.product-form__buttons')].find(element => visible(element));
        if (row) {
          // Let the existing checkout module retain its own position after the row.
          const sibling = row.nextElementSibling;
          const anchor = sibling?.classList.contains('lp-direct-checkout') ? sibling : row;
          if (anchor.nextElementSibling !== benefits) anchor.after(benefits);
        } else {
          const accordion = info.querySelector('.product__accordion');
          if (accordion && accordion.previousElementSibling !== benefits) accordion.before(benefits);
          else if (!accordion && benefits.parentElement !== info) info.append(benefits);
        }
      } else {
        if (benefits.parentElement !== slot) slot.append(benefits);
        const header = document.querySelector('.section-header');
        const headerHeight = header?.getBoundingClientRect().height || 0;
        // Taller galleries scroll naturally before their lower edge sticks;
        // the product grid still bounds the sticky column above later sections.
        // The header term sets how far the column may sit below the header;
        // the second term pins a taller column's bottom above the teaser.
        const top = Math.min(
          headerHeight + 12 + MAX_HEADER_DROP,
          window.innerHeight - media.offsetHeight - bottomClearance
        );
        const value = `${top}px`;
        if (root.style.getPropertyValue('--lp-benefits-sticky-top') !== value) {
          root.style.setProperty('--lp-benefits-sticky-top', value);
        }
      }
    }
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target !== root &&
          !record.target.closest?.('[data-lp-2d-benefits]'))) schedule();
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden', 'style'] });
    const resize = new ResizeObserver(schedule);
    resize.observe(media);
    const header = document.querySelector('.section-header');
    if (header) resize.observe(header);
    const help = benefits.querySelector('[data-lp-painting-help]');
    const onHelp = event => { event.preventDefault(); event.stopPropagation(); showDetails(help); };
    help?.addEventListener('click', onHelp);
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule);
    document.fonts?.ready.then(schedule);
    instances.set(root, () => {
      cancelAnimationFrame(frame);
      observer.disconnect(); resize.disconnect();
      mobile.removeEventListener('change', schedule);
      window.removeEventListener('resize', schedule);
      help?.removeEventListener('click', onHelp);
      instances.delete(root);
    });
    render();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-lp-2d-benefits-root]').forEach(enhance);
  }
  window.LP2DBenefits = { init };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-lp-2d-benefits-root]').forEach(root => instances.get(root)?.());
  });
})();
